import { all, call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
    ePhanPhoiDeThiActionIds,
    IPhanPhoiDeThiActionTypes,
} from "../../action-types/de-thi/IPhanPhoiDeThiActions";
import { phanPhoiDeThiApi } from "../../../api/de-thi/phanPhoiDeThiApi";

export function* phanPhoiDeThiSaga(): any {
    yield takeLatest(ePhanPhoiDeThiActionIds.LOAD_START, loadWorker);
    yield takeLatest(ePhanPhoiDeThiActionIds.PHAN_PHOI_START, PhanPhoiWorker);
    yield takeLatest(ePhanPhoiDeThiActionIds.THU_HOI_START, ThuHoiWorker);
    yield takeLatest(ePhanPhoiDeThiActionIds.LOAD_HISTORY_START, loadHistoryWorker);
}

// function* loadWorker(action: IPhanPhoiDeThiActionTypes): any {
//     const res: IBaseRespone = yield call(phanPhoiDeThiApi.SelectAll);
//     if (res.is_success) {
//         yield put(rootActions.deThi.phanPhoiDeThi.LOAD_SUCCESS(res.data));
//     } else {
//         yield put(
//             rootActions.deThi.phanPhoiDeThi.LOAD_ERROR(res.message ?? "Có lỗi")
//         );
//     }
// }

function* loadWorker(action: IPhanPhoiDeThiActionTypes): any {
    try {
        const [resDeThiTrongKhoTongs, resDeThiDaPhanPhoi]: [
            IBaseRespone,
            IBaseRespone
        ] = yield all([
            call(phanPhoiDeThiApi.SelectAll),
            call(phanPhoiDeThiApi.SelectDeThiDaPhanPhoi),
        ]);

        if (!resDeThiTrongKhoTongs.is_success) {
            yield put(
                rootActions.deThi.phanPhoiDeThi.LOAD_ERROR(
                    resDeThiTrongKhoTongs.message ?? "Có lỗi"
                )
            );
            return;
        }

        if (!resDeThiDaPhanPhoi.is_success) {
            yield put(
                rootActions.deThi.phanPhoiDeThi.LOAD_ERROR(
                    resDeThiDaPhanPhoi.message ?? "Có lỗi"
                )
            );
            return;
        }

        yield put(
            rootActions.deThi.phanPhoiDeThi.LOAD_SUCCESS({
                trongKhoTong: resDeThiTrongKhoTongs.data,
                daPhanPhoi: resDeThiDaPhanPhoi.data,
            })
        );
    } catch (error) {
        yield put(
            rootActions.deThi.phanPhoiDeThi.LOAD_ERROR("Có lỗi xảy ra")
        );
    }
}

function* PhanPhoiWorker(action: IPhanPhoiDeThiActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload;

    res = yield call(phanPhoiDeThiApi.PhanPhoi, payload);
    if (res) {
        if (res.is_success) {
            yield put(rootActions.deThi.phanPhoiDeThi.PHAN_PHOI_SUCCESS(undefined));
        } else {
            yield put(rootActions.deThi.phanPhoiDeThi.PHAN_PHOI_ERROR(res.message ?? "Có lỗi"));
        }
    }
}

function* ThuHoiWorker(action: IPhanPhoiDeThiActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload;

    res = yield call(phanPhoiDeThiApi.ThuHoi, payload);
    if (res) {
        if (res.is_success) {
            yield put(rootActions.deThi.phanPhoiDeThi.THU_HOI_SUCCESS(undefined));
        } else {
            yield put(rootActions.deThi.phanPhoiDeThi.THU_HOI_ERROR(res.message ?? "Có lỗi"));
        }
    }
}

function* loadHistoryWorker(action: IPhanPhoiDeThiActionTypes): any {
    const res: IBaseRespone = yield call(phanPhoiDeThiApi.SelectHistory, action.payload);
    if (res.is_success) {
        yield put(rootActions.deThi.phanPhoiDeThi.LOAD_HISTORY_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.deThi.phanPhoiDeThi.LOAD_HISTORY_ERROR(res.message ?? "Có lỗi")
        );
    }
}